<quill-editor
    class="quill-editor quill-editor--paybee angular-quill d-block"
    [ngClass]="quillClasses"
    format="object"
    placeholder=" "
    [modules]="modules"
    [readOnly]="readonly"
    (onEditorCreated)="getEditorInstance($event)"
    (onEditorChanged)="onEditorChanged($event)"
></quill-editor>
<span class="character-counter character-counter--paybee mt-1">{{quillLength - 1}}/{{limit}}</span>
